import { render, staticRenderFns } from "./BetSlipMarketView.vue?vue&type=template&id=4c1f398d"
import script from "./BetSlipMarketView.vue?vue&type=script&lang=js"
export * from "./BetSlipMarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports